import React from 'react'
import Main from './main'
import {Box} from '@mui/material';
import LoanOptions from './loanOptions';
import LoanCalculator from './loanCalculator';
import LoanEligibility from './loanEligibility';
import LoanSteps from './loanSteps';
import LoanFAQ from './loanFAQ';
import CTA from '../home/cta';
import Footer from '../../components/footer';
import { LoanApplyProvider } from './Component/LoanApplyContext';


const Index = () => {
  return (
    <LoanApplyProvider>
      <Box  sx={{
        '@media (min-width: 1700px)': {
            backgroundSize: '100%',
            maxWidth: '70vw',
            margin: 'auto'

         },
         '@media (min-width: 1600px) and (max-width: 1800px)': {
             backgroundSize: '100%',
             maxWidth: '90vw',
             margin: 'auto'

          },
     }}>
          <Main />
          <LoanOptions />
          <LoanCalculator />
          <Box
            sx={{
              position: "relative",
              width: "100vw",
              marginLeft: "calc(50% - 50vw)",
              background:
                "linear-gradient(to bottom, #FFFFFF 0%, #F6F4EE 25%, #F6F4EE 80%, #FFFFFF 100%)",
            }}
          >
            <Box
              sx={{
                "@media (min-width: 1700px)": {
                  maxWidth: "70vw",
                  margin: "auto",
                },
                "@media (min-width: 1600px) and (max-width: 1800px)": {
                  maxWidth: "90vw",
                  margin: "auto",
                },
              }}
            >
              <LoanEligibility />
              <LoanSteps />
            </Box>
          </Box>
          <LoanFAQ />
          <CTA />
          <Footer />
      </Box>
    </LoanApplyProvider>
  )
}

export default Index